import request from '@/utils/request'

// 我的反馈

let FeedbackApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/study.feedback/index', data, errorback);
  },

  /*回复*/
  reply(data, errorback) {
    return request._post('/shop/study.feedback/reply', data, errorback);
  },

  /*删除*/
  del(data, errorback) {
    return request._post('/shop/study.feedback/del', data, errorback);
  },

  /*状态*/
  status(data, errorback) {
    return request._post('/shop/study.feedback/status', data, errorback);
  },
}

export default FeedbackApi;



// WEBPACK FOOTER //
// ./src/api/study/feedback.js